export default "__VITE_ASSET__BgM49KXx__"